"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignUpThankYouEmailBody = exports.getSignUpThankYouEmailSignerName = exports.getSignUpThankYouEmailSubject = void 0;
const string_1 = require("../../helpers/string");
const locales_1 = require("../enums/locales");
const EMPTY_LINE = "<p><br></p>";
const getSignUpThankYouEmailSubject = (locale) => {
    const subjects = {
        [locales_1.Locales.EN]: "Thank you for subscribing! 💚",
        [locales_1.Locales.FR]: "Merci pour votre inscription ! 💚",
        [locales_1.Locales.ES]: "¡Gracias por suscribirte! 💚",
        [locales_1.Locales.DE]: "Danke für Ihre Anmeldung! 💚",
    };
    return subjects[locale];
};
exports.getSignUpThankYouEmailSubject = getSignUpThankYouEmailSubject;
const getSignUpThankYouEmailSignerName = ({ firstName, lastName, }) => [firstName, lastName].filter(Boolean).join(" ");
exports.getSignUpThankYouEmailSignerName = getSignUpThankYouEmailSignerName;
const getSignUpThankYouEmailBody = ({ locale, signerName }) => {
    const texts = {
        [locales_1.Locales.EN]: {
            message: "We're so glad to have you with us.<br>We'll keep you posted with news and updates from our team.",
            closing: "Warm regards,",
        },
        [locales_1.Locales.FR]: {
            message: "Nous sommes ravis de vous compter parmi nous.<br>Nous vous tiendrons au courant des nouvelles de notre équipe.",
            closing: "Chaleureusement,",
        },
        [locales_1.Locales.ES]: {
            message: "Nos alegra mucho tenerte con nosotros.<br>Te mantendremos al tanto de las novedades de nuestro equipo.",
            closing: "Saludos cordiales,",
        },
        [locales_1.Locales.DE]: {
            message: "Wir freuen uns sehr, Sie dabeizuhaben.<br>Wir halten Sie über Neuigkeiten aus unserem Team auf dem Laufenden.",
            closing: "Herzliche Grüße,",
        },
    };
    const { message, closing } = texts[locale];
    const signature = signerName.trim() ? `<br>${(0, string_1.escapeHtml)(signerName.trim())}` : "";
    return `<p>${message}</p>${EMPTY_LINE}<p>${closing}${signature}</p>`;
};
exports.getSignUpThankYouEmailBody = getSignUpThankYouEmailBody;
